import React from "react"
import { useEffect, useState } from 'react';
import "./gotop.scss"

const Gotop = () => {
    const [visible, setVisible] = useState(false)
    const isBrowser = typeof window !== "undefined";

    useEffect(() => {
        if (isBrowser) {
            window.addEventListener('scroll', toggleVisible);
        }
    }, [isBrowser]);

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 200) {
            setVisible(true)
        }
        else if (scrolled <= 200) {
            setVisible(false)
        }
    };

    return (
        <button onClick={() => { window.scrollTo({ top: 0, left: 0, behavior: 'smooth' }) }} className="top" style={{ display: visible ? 'block' : 'none' }}>
            <i className="material-icons">arrow_upward</i>
        </button>
    )
}

export default Gotop